import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Checkbox, FormControlLabel, Grid, IconButton, Tooltip, Typography } from '@mui/material';

import { roleToRoleInfo } from './utils/roles';

type RoleCheckboxesProps = {
  selectableRoles: string[];
  selectedRoles: string[];
  onSelectedRolesChange: (selectedRoles: string[]) => void;
};

export default function RoleCheckboxes({
  selectableRoles,
  selectedRoles,
  onSelectedRolesChange,
}: RoleCheckboxesProps): JSX.Element {
  const handleCheckboxChange = (role: string, checked: boolean) => {
    if (checked) {
      onSelectedRolesChange([...selectedRoles, role]);
    } else {
      onSelectedRolesChange(selectedRoles.filter((r) => r !== role));
    }
  };

  return (
    <>
      <Typography variant="h6" component="h6" my={2} fontWeight="bold">
        Select Roles
      </Typography>
      <Grid container item>
        {selectableRoles.map((role) => (
          <Grid key={role} item xs={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedRoles.includes(role)}
                  onChange={(_, checked) => handleCheckboxChange(role, checked)}
                />
              }
              label={
                <Grid container alignItems="center" spacing={0.1} wrap="nowrap" display="flex">
                  <Grid item zeroMinWidth>
                    {roleToRoleInfo[role].name}
                  </Grid>
                  <Grid item>
                    <Tooltip title={roleToRoleInfo[role].info} enterTouchDelay={200} placement="top-start" arrow>
                      <IconButton>
                        <InfoOutlinedIcon fontSize="small" color="primary" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              }
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
